export const getEnvVar = () => {
 return{
 
    ...process.env,
 } 
}